import {
    createSignInSchema,
    createSignUpSchema,
    type SignInFormSchema,
    type SignUpFormSchema,
} from '@fiverr-private/identification_core';

export { createSignInSchema, createSignUpSchema };

export type FormSchema = SignInFormSchema | SignUpFormSchema;

export const FieldName: Record<keyof FormSchema, keyof FormSchema> = {
    usernameOrEmail: 'usernameOrEmail',
    password: 'password',
};
